import './ChooseLangDialog.less';
import { setUserLang, getUserLang, getUserLangForReport } from '../../utils/util';
import { addURLSearch } from './../../web-tools/utils/util';
import { beaconReport } from './../../common/util';

const Id = 'ChooseLangDialog';
let rootEl = document.getElementById(Id);
if (!rootEl) {
  rootEl = document.createElement('div');
  rootEl.id = Id;
  document.getElementById('contentCtrl').appendChild(rootEl);
}

const LangArray = [{ v: 'zh-CN', t: '简体中文' }, { v: 'en', t: 'English' }];

const defaultClick = function (v) {
  const curLang = getUserLang();
  // 当前语言一致不刷新
  if (v === curLang) {
    return false;
  }
  setUserLang(v);
  // 将语言加到浏览器中
  window.history.replaceState(
    null,
    document.title,
    addURLSearch(window.location.href, { locale: v }),
  );
  beaconReport('web_invitedpage_null_switchlanguages_null_null_click', {
    pagelanguage: getUserLangForReport(v),
  });
  window.location.reload();
};

const ChooseLangDialog = (opts) => {
  let langs = '';
  (opts.LangArray || LangArray).forEach((lang) => {
    langs += `<div class="item">
    <span value="${lang.v}" class="txt">${lang.t}</span>
  </div>`;
  });
  rootEl.innerHTML = `
    <div class="dialog-mask"></div>
    <div class="dialog-wrap">
      <div class="dialog-wrap-btn">
        ${langs}
      </div>
    </div>
    `;
  rootEl.style.display = 'block';
  // 选择语言
  const chooseBtn = rootEl.querySelectorAll('.dialog-wrap .dialog-wrap-btn .item');
  chooseBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const el = e.target.querySelector('.txt') || e.target;
      opts.click ? opts.click(el.getAttribute('value')) : defaultClick(el.getAttribute('value'));
    }, false);
  });
  // 关闭
  const closeTriggerEl = rootEl.querySelector('.dialog-mask');
  closeTriggerEl.addEventListener('click', () => {
    ChooseLangDialog.close();
    opts.closeFn && opts.closeFn();
  }, false);
};

ChooseLangDialog.show = (options) => {
  const opts = Object.assign({}, {
    confirmFn: () => { },
    closeFn: () => { },
  }, options);

  const dialogWrapEl = rootEl.querySelector('.dialog-wrap');
  if (!dialogWrapEl) {
    ChooseLangDialog(opts);
    return true;
  }
  rootEl.style.display = 'block';
};

ChooseLangDialog.close = () => {
  rootEl.style.display = 'none';
};

export default ChooseLangDialog;
